<template>
  <div class="accordion faq-accordion" id="parent">
      <ItemPart :content="content" :title="title" parent-id="parent" v-for="({ title, content}) in data" :key="title"></ItemPart>
  </div>

</template>
<script>

//import ItemPart from "@/components/accordion/ItemPart";
import ItemPart from "@/components/accordion/ItemPart";
import axios from "axios";
import common from "@/config/common";
export default {
  components: {ItemPart},
  computed: {
    code(){
      return this.$product + '_' + this.$i18n.locale;
    }
  },
  data: function (){
      return {
        data: {}
      }
  },
  created() {
    var self = this;
    axios.get(common.API_BASE_URL + this.$product +'/'+ this.$i18n.locale +'/questions') // 'getCityByPostcode/' + this.formData.postcode
        .then(response => {
          self.data = response.data;
        })
        .catch(error => {
          console.log(error);
          //alert('fetchError' + error);
        })
  },
}
</script>
<style>
.faq-accordion{
  --bs-accordion-bg: var(--bs-light, #f8f9fa);
  --bs-accordion-btn-bg: var(--bs-light, #f8f9fa);
  --bs-accordion-active-bg: var(--bs-light, #f8f9fa);
  --bs-accordion-active-color: var(--main-color);
  --bs-accordion-btn-focus-box-shadow: none;
  background-color: var(--bs-light, #f8f9fa);
}

.faq-accordion .accordion-item{
  border: none;
  border-bottom: 1px solid var(--second-color);
  border-radius: 0;
  background-color: var(--bs-light, #f8f9fa);
}

.faq-accordion .accordion-button{
  padding: 0.85rem var(--bs-accordion-btn-padding-x, 1.25rem);
  background-color: var(--bs-light, #f8f9fa);
  border: none;
  box-shadow: none;
  color: #2c3e50;
  font-size: 1.05rem;
}

.faq-accordion .accordion-button:hover,
.faq-accordion .accordion-button:focus,
.faq-accordion .accordion-button:active{
  box-shadow: none;
  background-color: var(--bs-light, #f8f9fa);
  color: #2c3e50;
}

.faq-accordion .accordion-button:not(.collapsed){
  color: var(--main-color);
  background-color: var(--bs-light, #f8f9fa);
}

.faq-accordion .accordion-button:not(.collapsed)::after{
  filter: hue-rotate(249deg);
}

.faq-accordion .accordion-collapse,
.faq-accordion .accordion-body{
  padding: 0.25rem var(--bs-accordion-btn-padding-x, 1.25rem) 1rem;
  text-align: justify;
  background-color: var(--bs-light, #f8f9fa);
}
</style>